"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Title_1 = __importDefault(require("antd/lib/typography/Title"));
var Text_1 = __importDefault(require("antd/lib/typography/Text"));
var FormatText_1 = __importDefault(require("../../components/FormatText"));
var Icon_1 = __importDefault(require("../../components/Icon"));
exports.default = (function () { return (react_1.default.createElement("div", { className: "ant-app-view-forbidden" },
    react_1.default.createElement(Icon_1.default, { name: "commons-cancel" }),
    react_1.default.createElement(Title_1.default, { level: 3 },
        react_1.default.createElement(FormatText_1.default, { id: "ui.message.view.forbidden" })),
    react_1.default.createElement(Text_1.default, null,
        react_1.default.createElement(FormatText_1.default, { id: "ui.message.view.forbidden.description" })))); });
